import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Preloader } from '@/components/Preloader';
import { StartupCard } from '@/components/Cards/StartupCard/v3';
import { APP_LINKS } from '@/helpers/links';
import { useWindowSize } from '@/hooks/useWindowSize.js';
import { useGetInactiveBrands } from '@/query/queries/brand/useGetInactiveBrands.js';
import s from './index.module.scss';

export const BrandsAll = () => {
  const { t } = useTranslation('brands');
  const { innerWidth } = useWindowSize();
  const {
    data: brands,
    hasNextPage,
    isLoading,
    fetchNextPage,
  } = useGetInactiveBrands();

  const hasBrands = !!brands?.pages[0]?.total_count;

  return (
    <div className={s.startups_all}>
      <h2 className="f-26 f-500">
        {t('startups.other.title')}{' '}
        {hasBrands && `(${brands.pages[0].total_count})`}
      </h2>
      <p className={classnames(s.startups_all__desc, 'f-16 f-400')}>
        {t('startups.other.description')}
      </p>
      {isLoading && !hasBrands ? (
        <Preloader className={s.startups_all__preloader} />
      ) : hasBrands ? (
        <InfiniteScroll
          dataLength={Number(brands?.pages.length) || 0}
          next={fetchNextPage}
          hasMore={hasNextPage}
          scrollableTarget={innerWidth >= 1380 && 'main'}
          scrollThreshold={0.5}
          className={s.startups_all__list}
          loader={null}
        >
          {brands?.pages.map(page =>
            page.list.map(startup => (
              <StartupCard
                key={startup.id}
                startup={startup}
                href={APP_LINKS.startupDetail(startup.slug)}
                className={s.startups_all__card}
                hideFR
              />
            )),
          )}
        </InfiniteScroll>
      ) : (
        <div className={s.startups_all__empty}>
          <span
            className={classnames(s.startups_all__empty_title, 'f-16 f-400')}
          >
            {t('startups.other.no_brands')}
          </span>
        </div>
      )}
    </div>
  );
};
